import moment from 'moment';
export class OneTimePinModel {
    constructor(payload) {
        Object.assign(this, payload);
    }
    get parsedActivatedAt() {
        const activatedAt = new Date(this.activatedAt);
        return moment(activatedAt).format('MMM D, Y');
    }
}
